import classnames from 'classnames';

import { getId, getAriaHidden } from '../../../utils/a11y';
import { withI18n } from '../../services/i18n';

import type { I18n } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

import STYLES from './OTALogo.module.scss';

type OTALogoProps = {
  height: number;
  src: string;
  name: string;
  testId?: string;
  className?: string;
  index?: number;
  i18n: I18n;
  large?: boolean;
};

const OTALogo = ({
  className = undefined,
  height,
  i18n,
  index = undefined,
  large = false,
  name,
  src,
  testId = undefined,
}: OTALogoProps) => {
  const imageNode = (
    <img
      src={src.replace(/(.*d_ct.png)$/g, '$1?t=2022')}
      alt={name}
      height={height}
      data-test-id={testId}
      className={STYLES.OTALogo__asset}
    />
  );

  return (
    <div
      className={classnames(
        STYLES.OTALogo,
        { [STYLES.OTALogo__flex]: !large },
        className,
      )}
      id={getId('hotel_partner', index)}
      aria-hidden={getAriaHidden(index)}
    >
      {imageNode}
    </div>
  );
};

export default withI18n(OTALogo);
